import {
    OcGenericDialogFieldStringProps,
    OcGenericDialogFieldEnumProps,
    OcGenericDialogGroupProps,
    OcGenericDialogProps
} from '@oc/components'
import {User} from '@oc/user-management'

export enum EditProfileDialogActions {
    Cancel = 'cancel',
    Update = 'update'
}

export interface EditProfileDialogUserInformationGroup extends OcGenericDialogGroupProps<User> {
    fields: {
        username: OcGenericDialogFieldStringProps<User>
        givenName: OcGenericDialogFieldStringProps<User>
        familyName: OcGenericDialogFieldStringProps<User>
        email: OcGenericDialogFieldStringProps<User>
        phoneNumber: OcGenericDialogFieldStringProps<User>
    }
}

export interface EditProfileDialogUserGroupsGroup extends OcGenericDialogGroupProps<User> {
    fields: {
        groups: OcGenericDialogFieldEnumProps<User>
    }
}

export interface EditProfileDialogDatagroups
    extends Record<string, EditProfileDialogUserInformationGroup | EditProfileDialogUserGroupsGroup> {
    userInformation: EditProfileDialogUserInformationGroup
    userGroups: EditProfileDialogUserGroupsGroup
}

export interface EditProfileDialogProps extends OcGenericDialogProps<User> {
    dataGroups: EditProfileDialogDatagroups
}
